var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOrderSettingsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 59.27,
    height: 65.855,
    viewBox: "0 0 59.27 65.855",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Gruppe 95",
    transform: "translate(-970.125 -261.041)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2329",
    d: "M55.684,7.586H41.921a9.839,9.839,0,0,0-18.571,0H9.586A6.6,6.6,0,0,0,3,14.171v46.1a6.6,6.6,0,0,0,6.586,6.586h46.1A6.6,6.6,0,0,0,62.27,60.27v-46.1A6.6,6.6,0,0,0,55.684,7.586Zm-23.049,0a3.293,3.293,0,1,1-3.293,3.293A3.3,3.3,0,0,1,32.635,7.586Z",
    transform: "translate(967.125 260.041)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fill-background",
    "data-name": "Pfad 2335",
    d: "M47.26,20.093,52.182,15.7l-3.969-6.88-6.3,2.064a10.491,10.491,0,0,0-2.487-1.429L38.1,3H30.167L28.844,9.456a12.022,12.022,0,0,0-2.54,1.429L20.059,8.821,16.09,15.7l4.922,4.392a11.965,11.965,0,0,0,0,2.752l-4.922,4.5,3.969,6.88,6.35-2.011a12.162,12.162,0,0,0,2.276,1.323l1.482,6.509H38.1l1.429-6.456a12.6,12.6,0,0,0,2.328-1.323l6.3,2.011,3.969-6.88-4.922-4.5A12.54,12.54,0,0,0,47.26,20.093ZM34.136,28.137a6.615,6.615,0,1,1,6.615-6.615A6.617,6.617,0,0,1,34.136,28.137Z",
    transform: "translate(965.755 277.977)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderSettingsIcon);
export default __webpack_public_path__ + "static/media/orderSettingsIcon.c76ff364.svg";
export { ForwardRef as ReactComponent };